import { ElementRef, SimpleChanges } from "@angular/core";
import { Conversationn } from '../../../shared/model/conversationn.model';
import moment from "moment";
import { SessionStorageService } from "ngx-webstorage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseComponent } from '../../../shared/base.component';
import { OfflineMessageService } from '../../offline-message/offline-message.service';
import { FindLanguageFromKeyPipe } from '../../../shared/language/find-language-from-key.pipe';
import { UserService } from '../../../core/user/user.service';
import { SessionService } from '../../session/session.service';
import { LANGUAGES } from '../../../app.constants';
import { JhiEventManager } from '../../../ng-jhipster/service';
import { Session } from '../../../shared/model/session.model';
import * as i0 from "@angular/core";
import * as i1 from "../../../shared/language/find-language-from-key.pipe";
import * as i2 from "../../../core/user/user.service";
import * as i3 from "../../session/session.service";
import * as i4 from "../../../ng-jhipster/service";
import * as i5 from "../../offline-message/offline-message.service";
import * as i6 from "ngx-webstorage";
import * as i7 from "@ng-bootstrap/ng-bootstrap";
import * as i8 from "@angular/common";
import * as i9 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i10 from "@angular/forms";
const _c0 = ["customerCareModal"];
function CustomerCareInfoComponent_div_3_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵproperty("ngValue", item_r6.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r6.name);
} }
function CustomerCareInfoComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "label", 27);
    i0.ɵɵtext(2, "Language");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "select", 28);
    i0.ɵɵlistener("ngModelChange", function CustomerCareInfoComponent_div_3_Template_select_ngModelChange_3_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.selectedConversation.user.langKey = $event; })("change", function CustomerCareInfoComponent_div_3_Template_select_change_3_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.updateUserLanguage(ctx_r9.selectedConversation.user); });
    i0.ɵɵtemplate(4, CustomerCareInfoComponent_div_3_option_4_Template, 2, 2, "option", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngModel", ctx_r0.selectedConversation.user.langKey);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.languages);
} }
function CustomerCareInfoComponent_div_86_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const voucherCode_r10 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(voucherCode_r10);
} }
function CustomerCareInfoComponent_div_90_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 31);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const organizationCode_r11 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(organizationCode_r11);
} }
function CustomerCareInfoComponent_ng_template_91_h5_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "h5", 36);
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("jhiTranslate", ctx_r13.modalMessage);
} }
function CustomerCareInfoComponent_ng_template_91_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 32);
    i0.ɵɵtemplate(1, CustomerCareInfoComponent_ng_template_91_h5_1_Template, 1, 1, "h5", 33);
    i0.ɵɵelement(2, "br");
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementStart(4, "div", 34);
    i0.ɵɵelementStart(5, "button", 35);
    i0.ɵɵlistener("click", function CustomerCareInfoComponent_ng_template_91_Template_button_click_5_listener() { const restoredCtx = i0.ɵɵrestoreView(_r15); const modal_r12 = restoredCtx.$implicit; return modal_r12.close("close"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.modalMessage);
} }
export class CustomerCareInfoComponent extends BaseComponent {
    constructor(findLanguageFromKeyPipe, userService, sessionService, eventManager, offlineMessageService, sessionStorage, modalService) {
        super(sessionStorage, modalService);
        this.findLanguageFromKeyPipe = findLanguageFromKeyPipe;
        this.userService = userService;
        this.sessionService = sessionService;
        this.eventManager = eventManager;
        this.offlineMessageService = offlineMessageService;
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
    }
    ngOnInit() {
        this.userService.getAllAvailableLanguages().subscribe(res => {
            this.langKeys = res;
            this.languages = LANGUAGES.filter(l => this.langKeys.includes(l.code));
        });
        this.sessionService.getPastSessionCounts(this.selectedConversation.user.id).subscribe(res => {
            this.pastSessionCounts = res.body;
            console.log(this.pastSessionCounts);
        });
        this.customerCareInfoUpdatedSubscription = this.eventManager.subscribe('customerCareInfoUpdated', (response) => {
            console.log(response.content);
            if (response.content != null) {
                this.peerNextSessionDate(this.selectedConversation, response.content);
            }
            else {
                this.selectedConversation.nextSession = null;
                this.peerNextSessionDate(this.selectedConversation);
            }
        });
    }
    ngOnChanges(changes) {
        console.log(this.selectedConversation);
        this.sessionService.getPastSessionCounts(this.selectedConversation.user.id).subscribe(res => {
            this.pastSessionCounts = res.body;
            console.log(this.pastSessionCounts);
        });
    }
    peerLastSeen(c) { return c.lastMessage ? this.timeDateFormatted(c.lastMessage.createDate) : ""; }
    peerCreationDate(c) { return this.timeDateFormatted(moment(c.createDate)); }
    peerLastCoach(c) { return c.lastEndedSession ? c.lastEndedSession.coach.login : ""; }
    peerLastSessionDate(c, uDate) {
        if (uDate != null) {
            if (this.selectedConversation.lastEndedSession != null) {
                this.selectedConversation.lastEndedSession.sessionStartTime = uDate;
            }
            else {
                this.selectedConversation.lastEndedSession = new Session();
                this.selectedConversation.lastEndedSession.sessionStartTime = uDate;
            }
            this.peerLastSessionDate(this.selectedConversation);
        }
        return c.lastEndedSession ? this.timeDateFormatted(moment(c.lastEndedSession.sessionStartTime)) : "";
    }
    peerNextSessionDate(c, uDate) {
        if (uDate != null) {
            if (this.selectedConversation.nextSession != null) {
                this.selectedConversation.nextSession.sessionStartTime = uDate;
            }
            else {
                this.selectedConversation.nextSession = new Session();
                this.selectedConversation.nextSession.sessionStartTime = uDate;
            }
            this.peerNextSessionDate(this.selectedConversation);
        }
        return c.nextSession ? this.timeDateFormatted(moment(c.nextSession.sessionStartTime)) : "";
    }
    updateUserLanguage(u) {
        let langKey = u.langKey;
        this.userService.updateUserLanguage(u).subscribe(res => {
            console.log(res);
            if (langKey === res.langKey) {
                this.modalMessage = 'inukaNgApp.langKeyUpdated';
                this.modalService.open(this.customerCareModal).result.then((result) => console.log(result));
            }
        });
    }
}
CustomerCareInfoComponent.ɵfac = function CustomerCareInfoComponent_Factory(t) { return new (t || CustomerCareInfoComponent)(i0.ɵɵdirectiveInject(i1.FindLanguageFromKeyPipe), i0.ɵɵdirectiveInject(i2.UserService), i0.ɵɵdirectiveInject(i3.SessionService), i0.ɵɵdirectiveInject(i4.JhiEventManager), i0.ɵɵdirectiveInject(i5.OfflineMessageService), i0.ɵɵdirectiveInject(i6.SessionStorageService), i0.ɵɵdirectiveInject(i7.NgbModal)); };
CustomerCareInfoComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CustomerCareInfoComponent, selectors: [["customer-care-info"]], viewQuery: function CustomerCareInfoComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.customerCareModal = _t.first);
    } }, inputs: { selectedConversation: "selectedConversation" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 93, vars: 18, consts: [[1, "mt-4"], [1, "flex-grow-1", 2, "overflow-y", "scroll", "overflow-x", "scroll"], ["class", "text-default-div", 4, "ngIf"], [1, "text-default-div"], ["jhiTranslate", "inukaNgApp.email", 1, "text-default", 2, "font-weight", "bold"], [1, "text-default"], ["jhiTranslate", "inukaNgApp.country", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.region", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.timeZone", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.phone", 1, "text-default", 2, "font-weight", "bold"], [2, "margin", "10px 0 10px 0"], ["jhiTranslate", "inukaNgApp.userProperties", 1, "text-default", 2, "size", "16px", "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.yourTime", 1, "text-default"], ["jhiTranslate", "inukaNgApp.lastSeen", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.createdOn", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.coach", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.lastEndedSession", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.nextSession", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.endedSessions", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.noShowUsers", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.noShowCoaches", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.noOneShowed", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.credits", 1, "text-default", 2, "font-weight", "bold"], ["jhiTranslate", "inukaNgApp.voucherCodes", 1, "text-default", 2, "font-weight", "bold"], [4, "ngFor", "ngForOf"], ["jhiTranslate", "inukaNgApp.orgCodes", 1, "text-default", 2, "font-weight", "bold"], ["customerCareModal", ""], ["jhiTranslate", "inukaNgApp.language", 1, "text-default", 2, "font-weight", "bold"], [1, "btn", "btn-mini", 3, "ngModel", "ngModelChange", "change"], [3, "ngValue", 4, "ngFor", "ngForOf"], [3, "ngValue"], [1, "badge", "badge-info"], [1, "modal-body", 2, "background-color", "white", "overflow-wrap", "break-word", "border-radius", "0.3rem", "text-align", "center"], ["class", "modal-title", 3, "jhiTranslate", 4, "ngIf"], [1, "alert-box-actions", 2, "text-align", "center"], ["type", "button", "jhiTranslate", "login.close", 1, "btn", "btn-dark", 3, "click"], [1, "modal-title", 3, "jhiTranslate"]], template: function CustomerCareInfoComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div");
        i0.ɵɵtemplate(3, CustomerCareInfoComponent_div_3_Template, 5, 2, "div", 2);
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵtext(6, "Email");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "span", 5);
        i0.ɵɵtext(8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 3);
        i0.ɵɵelementStart(10, "span", 6);
        i0.ɵɵtext(11, "Country");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "span", 5);
        i0.ɵɵtext(13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 3);
        i0.ɵɵelementStart(15, "span", 7);
        i0.ɵɵtext(16, "Region");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "span", 5);
        i0.ɵɵtext(18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 3);
        i0.ɵɵelementStart(20, "span", 8);
        i0.ɵɵtext(21, "Timezone");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "span", 5);
        i0.ɵɵtext(23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 3);
        i0.ɵɵelementStart(25, "span", 9);
        i0.ɵɵtext(26, "Phone");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "span", 5);
        i0.ɵɵtext(28);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(29, "hr", 10);
        i0.ɵɵelementStart(30, "div", 3);
        i0.ɵɵelementStart(31, "span", 11);
        i0.ɵɵtext(32, "User Properties");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(33, "br");
        i0.ɵɵelement(34, "span", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "div", 3);
        i0.ɵɵelementStart(36, "span", 13);
        i0.ɵɵtext(37, "Last seen");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "span", 5);
        i0.ɵɵtext(39);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(40, "div", 3);
        i0.ɵɵelementStart(41, "span", 14);
        i0.ɵɵtext(42, "Created on");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "span", 5);
        i0.ɵɵtext(44);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(45, "div", 3);
        i0.ɵɵelementStart(46, "span", 15);
        i0.ɵɵtext(47, "Coach");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(48, "span", 5);
        i0.ɵɵtext(49);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(50, "div", 3);
        i0.ɵɵelement(51, "span", 16);
        i0.ɵɵelementStart(52, "span", 5);
        i0.ɵɵtext(53);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(54, "div", 3);
        i0.ɵɵelement(55, "span", 17);
        i0.ɵɵelementStart(56, "span", 5);
        i0.ɵɵtext(57);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(58, "div", 3);
        i0.ɵɵelementStart(59, "span", 18);
        i0.ɵɵtext(60, "Ended sessions");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(61, "span", 5);
        i0.ɵɵtext(62);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(63, "div", 3);
        i0.ɵɵelementStart(64, "span", 19);
        i0.ɵɵtext(65, "No show users");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(66, "span", 5);
        i0.ɵɵtext(67);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(68, "div", 3);
        i0.ɵɵelementStart(69, "span", 20);
        i0.ɵɵtext(70, "No show coaches");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(71, "span", 5);
        i0.ɵɵtext(72);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(73, "div", 3);
        i0.ɵɵelementStart(74, "span", 21);
        i0.ɵɵtext(75, "No show coaches");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(76, "span", 5);
        i0.ɵɵtext(77);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(78, "div", 3);
        i0.ɵɵelementStart(79, "span", 22);
        i0.ɵɵtext(80, "Credits");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(81, "span", 5);
        i0.ɵɵtext(82);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(83, "div", 3);
        i0.ɵɵelementStart(84, "span", 23);
        i0.ɵɵtext(85, "Voucher codes");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(86, CustomerCareInfoComponent_div_86_Template, 3, 1, "div", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(87, "div", 3);
        i0.ɵɵelementStart(88, "span", 25);
        i0.ɵɵtext(89, "Organization codes");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(90, CustomerCareInfoComponent_div_90_Template, 3, 1, "div", 24);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(91, CustomerCareInfoComponent_ng_template_91_Template, 6, 1, "ng-template", null, 26, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.selectedConversation.user.whatsappConversationId);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.selectedConversation.user.email);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.selectedConversation.user.country);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.selectedConversation.user.region);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.selectedConversation.user.timezone);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.selectedConversation.user.phoneNumber);
        i0.ɵɵadvance(11);
        i0.ɵɵtextInterpolate(ctx.peerLastSeen(ctx.selectedConversation));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.peerCreationDate(ctx.selectedConversation));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.peerLastCoach(ctx.selectedConversation));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.peerLastSessionDate(ctx.selectedConversation));
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.peerNextSessionDate(ctx.selectedConversation));
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.pastSessionCounts == null ? null : ctx.pastSessionCounts.endedCount);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.pastSessionCounts == null ? null : ctx.pastSessionCounts.noShowUserCount);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.pastSessionCounts == null ? null : ctx.pastSessionCounts.noShowCoachCount);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.pastSessionCounts == null ? null : ctx.pastSessionCounts.noOneShowedCount);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.selectedConversation.user.credits);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.selectedConversation.voucherCode == null ? null : ctx.selectedConversation.voucherCode.split(","));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.selectedConversation.organizationCode == null ? null : ctx.selectedConversation.organizationCode.split(","));
    } }, directives: [i8.NgIf, i9.JhiTranslateDirective, i8.NgForOf, i10.SelectControlValueAccessor, i10.NgControlStatus, i10.NgModel, i10.NgSelectOption, i10.ɵNgSelectMultipleOption], styles: [".text-default-div[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{vertical-align:middle}.text-default-div[_ngcontent-%COMP%]{padding-left:10px}select.btn-mini[_ngcontent-%COMP%]{height:auto;line-height:10px}select.btn[_ngcontent-%COMP%]{-webkit-appearance:button;-moz-appearance:button;padding:2px !important;margin-left:5px !important;font-size:14px !important;border:none !important;box-shadow:0 0 0 0 #fff !important}select.btn-mini[_ngcontent-%COMP%] + .caret[_ngcontent-%COMP%]{margin-left:-20px;margin-top:9px}"] });
